<template>
  <div class="vvip-wrap">
    <div class="vvip-frame">
      <div class="vvip-container">
        <div v-for="(vip, index) in allVipInfo" :key="index" :class="{'vvip-card': true, 'active': vip.level_name === currentVipName}">
          <div v-if="rebateInfo && rebateInfo.length > 0" class="card-lv-title">
            {{ rebateInfo[index+1][0] }}
          </div>
          <div class="card-pic">
            <img :src="vip.image_big" alt="">
          </div>
          <div v-if="tableData && tableData.length > 0" class="card-section">
            <div class="section-title">
              <i class="fa-solid fa-arrow-trend-up" aria-hidden="true" />
              {{ $t("Bao.vip_promotion_criteria") }}
            </div>
            <div v-if="tableData[2]" class="section-row">
              <div> {{ $t(tableData[2].label) }}</div>
              <div v-if="vip[`${tableData[2].key}_text_enable`]">
                {{ vip[`${tableData[2].key}_text`] }}
              </div>
              <div v-else>
                {{ formatNumber(vip[tableData[2].key]) }}
              </div>
            </div>
            <div v-if="tableData[3]" class="section-row">
              <div>{{ $t(tableData[3].label) }}</div>
              <div v-if="vip[`${tableData[3].key}_text_enable`]">
                {{ vip[`${tableData[3].key}_text`] }}
              </div>
              <div v-else>
                {{ formatNumber(vip[tableData[3].key]) }}
              </div>
            </div>
          </div>
          <div v-if="tableData && tableData.length > 0" class="card-section">
            <div class="section-title">
              <i class="fa-solid fa-gift" aria-hidden="true" />
              {{ $t("Bao.vip_exclusive_bonus") }}
            </div>
            <div v-if="tableData[0]" class="section-row">
              <div>{{ $t(tableData[0].label) }}</div>
              <div v-if="vip[`${tableData[0].key}_text_enable`]">
                {{ vip[`${tableData[0].key}_text`] }}
              </div>
              <div v-else>
                {{ formatNumber(vip[tableData[0].key]) }}
              </div>
            </div>
            <div v-if="themeConfig.showVipContent && tableData[1]" class="section-row">
              <div>{{ $t(tableData[1].label) }}</div>
              <div v-if="vip[`${tableData[1].key}_text_enable`]">
                {{ vip[`${tableData[1].key}_text`] }}
              </div>
              <div v-else>
                {{ formatNumber(vip[tableData[1].key]) }}
              </div>
            </div>
            <div v-if="tableData[4]" class="section-row">
              <div>{{ $t(tableData[4].label) }}</div>
              <div v-if="vip[`${tableData[4].key}_text_enable`]">
                {{ vip[`${tableData[4].key}_text`] }}
              </div>
              <div v-else>
                {{ vip[tableData[4].key] }}
              </div>
            </div>
          </div>
          <div v-if="vip.rebate_text && vip.rebate_text.length > 0 && tableData.length > 0" class="card-section">
            <div class="section-title">
              <i class="fa-solid fa-coins" aria-hidden="true" />
              {{ $t("Bao.vip_rebate") }}
            </div>
            <table class="game-table">
              <thead>
                <tr>
                  <th class="col-cat">
                    {{ $t("Bao.vip_game_category") }}
                  </th>
                  <th class="col-rate">
                    {{ $t("Bao.vip_rebate") }}
                  </th>
                  <th v-if="hasDailyMaxWin(vip)" class="col-rate">
                    {{ $t("Bao.vip_max_daily_win") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="rebate in vip.rebate_text.filter(item => item.enable === 1)"
                  :key="rebate.game_type_id"
                >
                  <td class="cat-name">
                    {{ rebate.game_type_name }}
                  </td>
                  <td class="rate-value">
                    {{ formatRebateText(rebate.text) }}
                  </td>
                  <td v-if="hasDailyMaxWin(vip)" class="rate-value">
                    {{ getDailyMaxWinText(vip, rebate.game_type_id) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- eslint-disable-next-line -->
      <div class="describe-frame" v-html="vipRule"></div>
    </div>
  </div>
</template>

<script>
import { page } from '@/api/common'
import { getAllVipInfo, getAllSpecialVipInfo, getRebateInfo } from '@/api/vip'
import { showNotice } from '@/utils/tool'
// import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'
import '@/assets/css/vip.css'

export default {
  mixins: [themeMixin],
  data() {
    return {
      allVipInfo: [],
      rebateInfo: [],
      litePlayer: null,
      currentVipLevel: 1,
      selectedVip: {
        key: 0,
        upgrade_prize: 0, // 升級獎勵
        keep_bet_amount_text: 0 // 保級流水
      },
      spec_icon_show: {
        upgrade_money: true,
        monthly_prize: true,
        birthday_prize: true
      },
      vipInfo: {},
      vipRule: ''
    }
  },
  computed: {
    // ...mapGetters(['']),
    currentVipName() {
      if (!this.$store.state.user ||
          !this.$store.state.user.vipInfo ||
          !this.litePlayer) {
        return ''
      }

      const matchNum = this.$store.state.user.vipInfo.currentVipName.match(/VIP(\d+)/)
      const matchChar = this.rebateInfo.find(array => array[0] === this.$store.state.user.vipInfo.currentVipName)

      if (matchNum) {
        const level = matchNum[1]
        let result = `VIP${level}`
        if (!level) {
          result = 'VIP9'
        }
        this.scrollToHighlighted()
        return result
      }

      if (matchChar) {
        this.scrollToHighlighted()
        return matchChar[0]
      }

      return ''
    },
    tableData() {
      const isShow = false
      const data = [
        {
          label: 'Bao.upgrade_prize_text',
          key: 'upgrade_prize'
        },
        {
          label: 'Bao.birthday_prize_text',
          key: 'birthday_prize'
        },
        {
          label: 'Bao.upgrade_bet_amount_text',
          key: 'upgrade_bet_amount'
        },
        {
          label: 'Bao.upgrade_deposit',
          key: 'upgrade_deposit'
        }]

      if (isShow) {
        data.push({
          label: 'Bao.keep_bet_amount',
          key: 'keep_bet_amount'
        })
      }
      return data
    }
  },
  created() {
    getAllVipInfo()
      .then((response) => {
        this.allVipInfo = response.data.data

        this.setCurrentVipLevel()
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })
    getAllSpecialVipInfo()
      .then((response) => {
        this.litePlayer = response.data.data
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })

    const timestamp = Date.now()
    page({ type: 'vip_rule', timestamp: timestamp }).then(response => {
      this.vipRule = response.data.data.content
    })
    this.scrollToHighlighted()
  },
  mounted() {
    getRebateInfo({ reverse_data: false })
      .then((response) => {
        this.rebateInfo = response.data.data
      })
      .catch((error) => {
        showNotice(error.response.data.msg)
      })
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) return ''
      return Number(value).toLocaleString()
    },
    hasDailyMaxWin(vip) {
      return Array.isArray(vip.daily_max_win_text) && vip.daily_max_win_text.some(item => item.enable === 1)
    },
    getDailyMaxWinText(vip, gameTypeId) {
      if (!Array.isArray(vip.daily_max_win_text)) return ''
      const found = vip.daily_max_win_text.find(item => item.game_type_id === gameTypeId && item.enable === 1)
      return found ? found.text : ''
    },
    formatRebateText(value) {
      if (value === null || value === undefined || value === '') return ''
      // 若為純數字(含小數)且數值不超過 100 則加上 %,否則直接顯示原字串
      const str = String(value).trim()
      if (!/^-?\d+(\.\d+)?$/.test(str)) return str
      return Number(str) > 100 ? Number(str).toLocaleString() : `${str}%`
    },
    scrollToHighlighted() {
      this.$nextTick(() => {
        setTimeout(() => {
          const highlightedItem = this.$el.querySelector('.vvip-card.active')
          if (highlightedItem) {
            highlightedItem.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 700)
      })
    },
    setCurrentVipLevel() {
      if (!this.$store.state.user ||
          !this.$store.state.user.vipInfo) {
        return
      }

      for (const i in this.allVipInfo) {
        if (this.$store.state.user.vipInfo.currentVipName === this.allVipInfo[i].level_name) {
          this.currentVipLevel = this.allVipInfo[i].level

          this.selectedVip = {
            key: i,
            upgrade_prize: this.allVipInfo[i].upgrade_prize,
            keep_bet_amount_text: this.allVipInfo[i].keep_bet_amount_text
          }
          this.setCurrentVipSpecIcon(this.allVipInfo[i].spec_icon_show)
        }
      }
    },
    setCurrentVipSpecIcon(select_spec_icon_show) {
      if (select_spec_icon_show) {
        this.spec_icon_show.upgrade_money = (select_spec_icon_show.indexOf('upgrade_money') > -1)
        this.spec_icon_show.monthly_prize = (select_spec_icon_show.indexOf('monthly_prize') > -1)
        this.spec_icon_show.birthday_prize = (select_spec_icon_show.indexOf('birthday_prize') > -1)
      } else {
        this.spec_icon_show = {
          upgrade_money: false,
          monthly_prize: false,
          birthday_prize: false
        }
      }
    }
  }
}
</script>

